import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import {
  Box,
  Button,
  TextField,
  LinearProgress,
  Alert,
  Paper,
  Typography,
  IconButton,
} from '@mui/material';
import { useParams, useNavigate, Link } from "react-router-dom";
import { useAppContext } from "../../../libs/contextLib";
import { useTranslation } from 'react-i18next';
import UseCaseTableList from "./UseCaseTableList";
import ScenarioTableCreate from "./ScenarioTableCreate";

function ScenarioManage() {
  const { t } = useTranslation();
  const { isAuthenticated } = useAppContext();
  const [isLoading, setIsLoading] = useState(true);
  const history = useNavigate();
  const { currentLocation, setCurrentLocation } = useAppContext();
  setCurrentLocation('/mmmanage');

  useEffect(() => {
    async function onLoad() {

    }

    onLoad();
  }, []);

  return (
    <div className="content-section">
            <Typography variant="h6" gutterBottom>
              데이터 획득현황
            </Typography>
          <div className="bg-light">
          <UseCaseTableList />
        </div>
        <div className="bg-light">
          <ScenarioTableCreate />
        </div>
    </div>
  );
};

export default ScenarioManage;